import axios from 'axios';
import { serviceInstance } from '../axiosinstance';

// media services axios client
export const mediaServicesInstance = axios.create({
  baseURL: process.env.REACT_APP_MEDIA_SERVICES_API_BASE_URL || 'https://mediaservices.kit19.com/',
  headers: {
    'Content-Type': 'application/json',
  },
});
let mediaData = null;

// Helper function to parse data if it's a string
const parseData = (data) => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn('Failed to parse data as JSON:', error);
      return data;
    }
  }
  return data;
};
export const getStorageLibraryList = async (ReceivedLink, parentid, userid,token) => {

  //  if (mediaData) {
    // console.log("Using cached mediaData");
  //   return mediaData;
  // }

  try {
    const response = await mediaServicesInstance.post('medialibrary/GetStorageLibraryList', {
      ReceivedLink,
      parentid,
      userid,
      token
    });
  
    // mediaData = response.data;
    // return mediaData;
    return parseData(response.data);
  } catch (error) {
    console.error('Error fetching conversation:', error);
    throw error;
  }

};


// when you click on the save
export const uploadbulkFile = async (file, directory, token) => {
  try {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("directory", directory);
    formData.append("files", file); // pass actual File object

    const response = await mediaServicesInstance.post("medialibrary/UploadbulkFile",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return parseData(response.data);
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};




// when you click on the select
export const sendMessage = async (key, username, name, to, type,imageLink) => {
  try {
    const response = await serviceInstance.post('IMS/Internal/Message', {
      key,
      username,
      name,
      whatsapp: {
        to,
        type,
        image: {
          link: imageLink
        }
      }
    });
    return parseData(response.data);
  } catch (error) {
    console.error('Error sending WhatsApp image message:', error);
    throw error;
  }
};






// memory(storage) usage left
export const getQuota = async (parentid, userid) => {
  try {
    const response = await mediaServicesInstance.post('medialibrary/GetQuota',
      {
        parentid,
        userid,
      }
    );
    return parseData(response.data);
  } catch (error) {
    console.error('Error fetching storage quota:', error);
    throw error;
  }
};